export
const name: string = "ShadowMapBlur16";

export
const preproc: string = `
    //#version 100

    //precision mediump float;
`;

export
const declaration: string = `
    uniform vec2 u_textureSize;
    uniform vec2 u_direction;
    uniform sampler2D u_texture;
`;

export
const varyings: string = `
    varying vec2 v_texcoords;
`;

export
const implementation: string = `
    vec2 blurPacked(sampler2D image, vec2 uv, float factor) {
      vec4 data = texture2D(image, uv);
      float a = unpackFloat(vec2(data.x, data.y));
      float b = unpackFloat(vec2(data.z, data.w));
      return vec2(a, b) * factor;
    }

    vec4 blur5Packed(sampler2D image, vec2 uv, vec2 resolution, vec2 direction) {
      vec2 color = vec2(0.0);
      vec2 off1 = vec2(1.3333333333333333) * direction;
      color += blurPacked(image, uv, 0.29411764705882354);
      color += blurPacked(image, uv + (off1 / resolution), 0.35294117647058826);
      color += blurPacked(image, uv - (off1 / resolution), 0.35294117647058826);
      return vec4(packFloat(color.x), packFloat(color.y));
    }


    void main() {
        gl_FragColor = blur5Packed(u_texture, v_texcoords, u_textureSize, u_direction);
    }
`;
